import styled from 'styled-components';
import { COLOR } from '../../../styles/variables';
import { mainConfig } from '../../../config/config.provider';

export const ImageList = styled.ul`
    font-size: 0.8rem;
    padding: 0.5rem 0;
    color: black;
    text-decoration: none;
    font-family: Standard;
    font-weight: normal;
    margin: 0 0.8rem 0.8rem 0;
    list-style: none;
`;

export const ImageEntry = styled.li`
    display: inline-block;
    position: relative;

    :not(:first-child) {
        margin-left: -15px;
    }
`;

export const ImageLink = styled.a<{ img?: string; index?: number; isActive?: boolean }>`
    display: inline-block;
    box-shadow: rgb(0 0 0 / 50%) 2px 2px 5px;
    background-color: ${COLOR.br24.darkBlueGrey};
    background-image: url(${({ img }) => img});
    background-repeat: no-repeat;
    background-size: cover;
    text-decoration: none;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    transition: transform 0.25s ease;
    transform: ${({ isActive }) => (isActive ? `scale(1.1);` : '')};

    :hover {
        transform: scale(1.05);
    }
`;

export const NameList = styled.ul`
    list-style: none;
    padding: 0;
`;

export const NameEntry = styled.li``;

export const NameLink = styled.a<{ isActive?: boolean; isDark?: boolean }>`
    text-decoration: none;
    color: ${({ isActive, isDark }) => (isActive ? COLOR.br24.blue : isDark ? 'black' : 'white')};

    :hover {
        color: ${COLOR.br24.blue};
    }
`;
